import {getAxios} from './axios'
import {responseResolveInterceptor} from 'backend-helpers/interceptors';

export function getProfileWishlist(nick) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/profile/wishlist/',
        method: 'get',
        params: {nick}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/profileWishlist.js